import { render } from "./GetOrderCarrier.vue?vue&type=template&id=195376b7"
import script from "./GetOrderCarrier.vue?vue&type=script&lang=js"
export * from "./GetOrderCarrier.vue?vue&type=script&lang=js"
script.render = render

export default script